module.exports = __webpack_public_path__ + "OpenSans-ExtraBold.f525db7b833334aff6d3.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-ExtraBold.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-ExtraBold.ttf
// module chunks = styles